import { Box } from "@mui/material";

const CHIP_MAX_WIDTH = 90;

export const EllipsisText = ({
  children,
  maxWidth = CHIP_MAX_WIDTH,
}: {
  children: React.ReactNode;
  maxWidth?: number;
}) => (
  <Box
    sx={{
      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis",
      maxWidth,
      textAlign: "center",
    }}
  >
    {children}
  </Box>
);
